import {$, ID, Resource, TAG, ValidationMaxLength, ValidationRequired} from 'simpli-web-sdk'
import TipoChecklistEntregaSchema from '@/schema/TipoChecklistEntrega.schema'

export default class TipoChecklistEntrega extends Resource {

    get $schema() {
        return TipoChecklistEntregaSchema(this)
    }

    get $id() {
        return this.idTipoChecklistEntregaPk
    }

    set $id(val: ID) {
        this.idTipoChecklistEntregaPk = val
    }

    get $tag() {
        return this.descricao
    }

    set $tag(val: TAG) {
        this.descricao = val
    }

    readonly $name: string = 'TipoChecklistEntrega'

    readonly $endpoint: string = '/user/tipo-checklist-entrega{/id}'

    idTipoChecklistEntregaPk: ID = 0

    idOcorrenciaExterna: number | null = null

    @ValidationRequired()
    @ValidationMaxLength(255)
    descricao: string = ''

    @ValidationRequired()
    ativo: boolean = false

    async getTipoChecklistEntrega(spinner = 'getTipoChecklistEntrega') {
        const fetch = async () => await this.GET(`/user/tipo-checklist-entrega`)
        return await $.await.run(fetch, spinner)
    }
}
